import { IconArrowLeft, IconGraph, IconLogout2 } from '@tabler/icons-react';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  AppShell,
  Burger,
  Button,
  Group,
  Image,
  NavLink,
  ScrollArea,
  Stack,
  Timeline,
  useMantineColorScheme,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useAuth } from '@/contexts/AuthContext';
import { getLogoSvg } from '../Logo/LogoSvg';
import { ThemeSchemeToggle } from '../ThemeSchemeToggle/ThemeSchemeToggle';
import { UserMenu } from '../UserMenu/UserMenu';
import { navigationCreateEventLinks } from './navigationLinks';

const LayoutCreateEvent = () => {
  const eventId = useParams().eventId || 'novo';
  const [opened, { toggle, close }] = useDisclosure();
  const { colorScheme } = useMantineColorScheme();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const logoSvg = getLogoSvg();

  return (
    <AppShell
      header={{ height: 70 }}
      navbar={{
        width: { base: 300 },
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      pt="md"
    >
      <AppShell.Header
        bg={colorScheme === 'dark' ? '#191919' : 'white'}
        style={{ border: 'none', boxShadow: 'none' }}
      >
        <Group h="100%" px="md" justify="space-between" align="center">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <Link to="/dashboard/evento/tabela" style={{ textDecoration: 'none' }}>
            <Image w={185} src={logoSvg} alt="Brasil Arena" />
          </Link>

          <Group gap="xs">
            <ThemeSchemeToggle size={38} />
            <UserMenu size={38} />
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar
        p="md"
        bg={colorScheme === 'dark' ? '#191919' : 'white'}
        style={{
          borderTop: `1px solid ${colorScheme === 'dark' ? '#2e2e2e' : '#e9e9e9'}`,
          borderBottom: 'none',
          borderLeft: 'none',
          borderRight: 'none',
          boxShadow: 'none',
          justifyContent: 'space-between',
        }}
      >
        <ScrollArea type="never">
          <Button
            mb="lg"
            ml={5}
            fz={17}
            onClick={() => navigate('/dashboard/evento/tabela')}
            component="a"
            variant="subtle"
            color="principal"
            leftSection={<IconArrowLeft size={24} />}
          >
            Voltar para Campeonatos
          </Button>

          <Timeline bulletSize={24} lineWidth={2}>
            {navigationCreateEventLinks.map((item) => (
              <Timeline.Item key={item.id} bullet={item.step} title={item.title}>
                {item.links.map((link) => (
                  <NavLink
                    key={link.id}
                    mb={4}
                    onClick={close}
                    label={link.label}
                    leftSection={link.leftSection}
                    autoContrast
                    component={Link}
                    to={link.to.replace(':eventId', eventId || 'novo')}
                    disabled={eventId === 'novo' && link.id !== 11}
                    active={location.pathname === link.to.replace(':eventId', eventId || 'novo')}
                    color="green"
                  />
                ))}
              </Timeline.Item>
            ))}
          </Timeline>
        </ScrollArea>

        <Stack>
          <Button
            fz={17}
            onClick={() => {
              navigate(`/dashboard/evento/${eventId}/dashboard/painel-organizador`);
            }}
            component="a"
            color="principal.9"
            variant="filled"
            leftSection={<IconGraph size={24} />}
            disabled={eventId === 'novo'}
          >
            Painel do Organizador
          </Button>

          <Button
            fz={17}
            onClick={logout}
            component="a"
            color="gray"
            variant="subtle"
            href="/"
            leftSection={<IconLogout2 size={24} />}
          >
            SAIR
          </Button>
        </Stack>
      </AppShell.Navbar>

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};

export default LayoutCreateEvent;
